import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import moment from 'moment';
import { firstValueFrom } from 'rxjs';
import { ChartPieAngle } from 'src/app/Interfaces/Admin/charts/ChartPieAngle.interface';
import { LargeArea } from 'src/app/Interfaces/Admin/charts/LargeChartArea.interface';
import { ChartPie, DataPie } from 'src/app/Interfaces/Admin/charts/SimpleCharPie.interface';
import { Cont_Stadistic_FIN, Data_Complete_Cont_FIN, Data_Cont_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Reports/Data_Contribution_FIN.interface';
import { Response_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Response_FIN.interface';
import { LibraryFINService } from 'src/app/Services/Libraries/General-FIN/library-fin.service';
import { LibraryMasterService } from 'src/app/Services/Libraries/Library-Master/library-master.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-contributions-fin',
    templateUrl: './contributions-fin.component.html',
    styleUrls: ['./contributions-fin.component.scss', '../../../../../Styles/GlobalStyles.css'],
    standalone: false
})
export class ContributionsFINComponent implements OnInit {
  //+================== VARIABLES GENERAL ==================+\\
  public EndDate!: Date
  public StartDate!: Date

  public CurrentLibrarySlug: string = 'fin';
  public CurrentLibraryName: string = 'Processes';

  //+================== VARIABLES DATA LIBRARIES ==================+\\
  public DataChartAreaFIN: LargeArea = { Data: [], Date: [], SerieName: 'Contribuciones', Subtitle: ``, Title: 'Contribuciones totales Processes', Total: 0, load: true }
  public DataContributions: Data_Complete_Cont_FIN = {
    total: 0,
    media: 0,
    peak: 0,
    approved: 0,
    pending: 0,
    rejected: 0,
    totalCurrent: 0
  }
  public DataChartPieFIN: ChartPie = { Title: 'General Processes', percent: 75, Data: [], load: true }
  public DataChartPieAngleFIN: ChartPieAngle = { Title: 'Actuales en sistema', Percent: 75, InnerPercent: 40, Data: [], load: true }

  //+================== VARIABLES FOR COLOR SWETALERT ==================+\\
  private ColorConfirm: string = '#20a8e1';
  private ColorsCancel: string = '#fc6161';

  //+================== VARIABLES FOR TYPE FILES ==================+\\
  public Option_Type_Filter: any[] = [
    { Name: 'Día', Value: 1 },
    { Name: 'Semana', Value: 2 },
    { Name: 'Mes', Value: 3 },
    { Name: 'Año', Value: 4 }
  ];


  //+================== VARIABLES OPTIONS ==================+\\
  public Select_Option_Type_Filter = { Name: 'Mes', Value: 3 };

  //+================== VARIABLES FOR STATUS ==================+\\
  public Status_FIN = {
    Approved: 1,
    Pending: 2,
    Rejected: 3
  }

  public LoadPage: boolean = false;

  //-========================= SERVICES =========================-\\
  public Service_FIN = inject(LibraryFINService)
  private route = inject(ActivatedRoute);
  private MasterLibraryService = inject(LibraryMasterService);


  ngOnInit(): void {
    this.EndDate = new Date();
    this.route.paramMap.subscribe(async params => {
      const slugFromRoute = (params.get('libSlug') || 'fin').toLowerCase();
      this.CurrentLibrarySlug = slugFromRoute;
      await this.LoadLibraryDisplayName(slugFromRoute);
      this.ApplyDynamicTexts();
      this.Load_Cont_FIN();
    });
  }

  private async LoadLibraryDisplayName(slug: string): Promise<void> {
    try {
      if (slug === 'fin' || slug === 'processes') {
        this.CurrentLibraryName = 'Processes';
        return;
      }

      const res: Response_FIN = await firstValueFrom(this.MasterLibraryService.Get_Active_Libraries());
      const library = (res.operation || []).find((item: any) => String(item?.Slug || '').toLowerCase() === slug);
      this.CurrentLibraryName = String(library?.Nombre || slug.toUpperCase());
    } catch {
      this.CurrentLibraryName = slug.toUpperCase();
    }
  }

  private ApplyDynamicTexts(): void {
    this.DataChartAreaFIN = {
      ...this.DataChartAreaFIN,
      Title: `Contribuciones totales ${this.CurrentLibraryName}`
    };

    this.DataChartPieFIN = {
      ...this.DataChartPieFIN,
      Title: `General ${this.CurrentLibraryName}`
    };
  }

  //-================== FUNCTTION FOR LOAD CONT FIN ==================-\\
  private async Load_Cont_FIN(): Promise<void> {

    try {
      this.LoadPage = false;

      const resContributionFIN: Response_FIN = await firstValueFrom(this.Service_FIN.Get_Contribution_FIN({ Type: this.Select_Option_Type_Filter.Value, StartDate: this.StartDate ?? '', EndDate: this.EndDate, LibrarySlug: this.CurrentLibrarySlug }))

      if (resContributionFIN.success) {

        const DataContribution: Data_Cont_FIN[] = resContributionFIN.operation.Data
        const totalContribution: number = resContributionFIN.operation.total

        this.StartDate = moment(DataContribution[0].DateD, 'DD/MM/YYYY').toDate() ?? ''

        this.DataChartAreaFIN = {
          ...this.DataChartAreaFIN,
          Data: DataContribution.map((item: Data_Cont_FIN) => item.DataD),
          Date: DataContribution.map((item: Data_Cont_FIN) => item.DateD),
          Subtitle: `Periodo: ${moment(this.StartDate).utc().format('MM/DD/YYYY')} - ${moment(this.EndDate).utc().format('DD/MM/YYYY')}`,
          Total: totalContribution
        };

        const currentContribution: Cont_Stadistic_FIN[] = resContributionFIN.operation.currentContribution;

        this.DataContributions = {
          ...this.DataContributions,
          total: resContributionFIN.operation.total,
          media: Math.round(resContributionFIN.operation.media),
          peak: resContributionFIN.operation.peak,
          approved: currentContribution.find((item: Cont_Stadistic_FIN) => item.Status === this.Status_FIN.Approved)?.Total_Status ?? 0,
          pending: currentContribution.find((item: Cont_Stadistic_FIN) => item.Status === this.Status_FIN.Pending)?.Total_Status ?? 0,
          rejected: currentContribution.find((item: Cont_Stadistic_FIN) => item.Status === this.Status_FIN.Rejected)?.Total_Status ?? 0,
          totalCurrent: currentContribution.reduce((total, item: Cont_Stadistic_FIN) => total + item.Total_Status, 0)
        }

        const generalContribution: Cont_Stadistic_FIN[] = resContributionFIN.operation.generalContribution;

        const generalApproved: DataPie = { name: 'Aprobadas', value: generalContribution.find((item: Cont_Stadistic_FIN) => item.Status === this.Status_FIN.Approved)?.Total_Status ?? 0 }
        const generalRejected: DataPie = { name: 'rechazadas', value: generalContribution.find((item: Cont_Stadistic_FIN) => item.Status === this.Status_FIN.Rejected)?.Total_Status ?? 0 }

        const DataPieGeneral: DataPie[] = [];
        DataPieGeneral.push(generalApproved, generalRejected);

        this.DataChartPieFIN = {
          ...this.DataChartPieFIN,
          Data: DataPieGeneral
        }

        const currentApproved: DataPie = { name: 'Aprobadas', value: currentContribution.find((item: Cont_Stadistic_FIN) => item.Status === this.Status_FIN.Approved)?.Total_Status ?? 0 }
        const currentPending: DataPie = { name: 'Pendientes', value: currentContribution.find((item: Cont_Stadistic_FIN) => item.Status === this.Status_FIN.Pending)?.Total_Status ?? 0 }
        const currentRejected: DataPie = { name: 'rechazadas', value: currentContribution.find((item: Cont_Stadistic_FIN) => item.Status === this.Status_FIN.Rejected)?.Total_Status ?? 0 }

        const DataPieCurrent: DataPie[] = [];
        DataPieCurrent.push(currentApproved, currentPending, currentRejected);

        this.DataChartPieAngleFIN = {
          ...this.DataChartPieAngleFIN,
          Data: DataPieCurrent
        }

      }

      this.LoadPage = true;

    } catch (e) {
      Swal.fire({
        title: `Ocurrió un error (contribuciones ${this.CurrentLibraryName.toUpperCase()})`,
        text: '¡Recargue la página, si el problema persiste notifique a supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      });

      this.LoadPage = true;
    }

  }

  public Reload_Page(): void {
    this.Load_Cont_FIN();
  }

}
